// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf } from "@altostra/type-validations";
import { number, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGetGenerativeAiAgentsCampaignQaResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      tags: arrayOf(string),
      territory_ids: anyOf(arrayOf(string), nullOrUndefined),
      brand_guideline_id: anyOf(string, nullOrUndefined),
    })
  ),
  total: anyOf(number, nullOrUndefined),
});
